export default __webpack_public_path__ + "pin-red.725a857a.svg";